module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/2517beb185bd26441a21cd09eb1cac2b.png";